<template>
  <div class="text-orange">
    <template
      v-for="(item, index) in items"
    >
      <div
        :key="item.id || item.title"
        :class="{'border-b': (index != items.length - 1)}"
        class="text-lg font-sans-medium pb-3 pt-4 border-shadow-color cursor-pointer"
        @click="handle(item)"
      >
        {{ item.text || item.title }}
      </div>
    </template>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseMenuList',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handle(item) {
      if (item.onClick) {
        item.onClick();
      } else if (item.routeName) {
        this.$router.push(item.routeName);
      } else if (item.href) {
        window.open(item.href, '_blank');
      }
      this.$emit('itemClicked');
    },
  },
};
</script>

<style lang="css" scoped>
.router-link-exact-active {
  color: #000;
}
</style>
